import React from 'react';
import { statusColors } from './helpers';

const StatusBadge = ({ status, className = "" }) => {
  // Map status values for display
  const getDisplayStatus = (status) => {
    if (!status) return 'Unknown';

    switch (status?.toLowerCase()) {
      // Only transform these specific blog/article statuses
      case 'draft':
        return 'Draft';
      case 'archived':
        return 'Archived';
      // Keep all other statuses as-is (Active, Inactive, rescheduled, cancelled, etc.)
      default:
        return status;
    }
  };

  // Capitalize first letter of status
  const capitalizeFirstLetter = (str) => {
    if (!str || typeof str !== 'string') return 'Unknown';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Get status color class with fallback
  const getStatusColor = (status) => {
    if (!status) return statusColors.Default;
    return statusColors[status] || statusColors[status.toLowerCase()] || statusColors.Default;
  };

  const displayStatus = getDisplayStatus(status);
  const capitalizedStatus = capitalizeFirstLetter(displayStatus);
  const colorClass = getStatusColor(status);

  return (
    <span
      className={`inline-block px-2 py-1 text-xs font-medium rounded-lg border ${colorClass} ${className}`}
      style={{
        display: 'inline-block',
        minWidth: 'fit-content'
      }}
    >
      {capitalizedStatus}
    </span>
  );
};

export default StatusBadge;
